
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class NewsTitle extends Vue {
  @Prop({ default: '热点聚焦' }) name!: string;

  intoList(){
    this.$emit("more");
  }
}
